export const SelectInput = ({
	label,
	name,
	value,
	options,
	error,
	onChange,
	placeholder,
}) => {
	const isRequired = label.includes('*');
	return (
		<div className='input-group'>
			<label>
				{isRequired ? (
					<>
						{label.replace('*', '')}
						<span className='red-asterisk'>*</span>
					</>
				) : (
					label
				)}
				{error && <span className='error'>{error}</span>}
			</label>
			<select name={name} value={value} onChange={onChange}>
				{placeholder && (
					<option value='' disabled>
						{placeholder}
					</option>
				)}
				{options.map((option, index) => (
					<option value={option.id} key={index}>
						{option.name}
					</option>
				))}
			</select>
		</div>
	);
};

export const TextareaInput = ({
	label,
	name,
	value,
	error,
	onChange,
	placeholder,
}) => {
	const isRequired = label.includes('*');
	return (
		<div className='input-group textarea'>
			<label>
				{isRequired ? (
					<>
						{label.replace('*', '')}
						<span className='red-asterisk'>*</span>
					</>
				) : (
					label
				)}
				{error && <span className='error'>{error}</span>}
			</label>
			<textarea
				name={name}
				value={value}
				placeholder={placeholder}
				onChange={onChange}
			/>
		</div>
	);
};

export const TextInput = ({
	label,
	name,
	value,
	error,
	onChange,
	placeholder,
}) => {
	const isRequired = label.includes('*');
	return (
		<div className='input-group'>
			<label>
				{isRequired ? (
					<>
						{label.replace('*', '')}
						<span className='red-asterisk'>*</span>
					</>
				) : (
					label
				)}
				{error && <span className='error'>{error}</span>}
			</label>
			<input
				type='text'
				name={name}
				value={value}
				placeholder={placeholder}
				onChange={onChange}
			/>
		</div>
	);
};

export const EmailInput = ({
	label,
	name,
	value,
	error,
	onChange,
	placeholder,
}) => {
	const isRequired = label.includes('*');
	return (
		<div className='input-group'>
			<label>
				{isRequired ? (
					<>
						{label.replace('*', '')}
						<span className='red-asterisk'>*</span>
					</>
				) : (
					label
				)}
				{error && <span className='error'>{error}</span>}
			</label>
			<input
				type='email'
				name={name}
				value={value}
				placeholder={placeholder}
				onChange={onChange}
			/>
		</div>
	);
};

export const PhoneInput = ({
	label,
	name,
	value,
	error,
	onChange,
	placeholder,
}) => {
	const isRequired = label.includes('*');
	return (
		<div className='input-group'>
			<label>
				{isRequired ? (
					<>
						{label.replace('*', '')}
						<span className='red-asterisk'>*</span>
					</>
				) : (
					label
				)}
				{error && <span className='error'>{error}</span>}
			</label>
			<input
				type='tel'
				name={name}
				value={value}
				placeholder={placeholder}
				onChange={onChange}
			/>
		</div>
	);
};
